import React from 'react';

import { useIsAtVersionHistoryRoute } from 'src/helpers';
import { useGetCurrentDoc } from 'src/hooks';

import {
  setIsPageOutlineOpen,
  useIsPageOutlineOpen,
  useOutlineWidthBasedOnBreakpoint,
} from './config';
import { OutlineAnimationContainer } from './OutlineAnimationContainer';
import { OutlineMenu } from './OutlineMenu';
import { OutlineToggle } from './OutlineToggle';

interface Props {
  areHeadingsSupported?: boolean;
}

export function DocumentOutline({ areHeadingsSupported = true }: Props) {
  const { isPageOutlineOpen: isOpen } = useIsPageOutlineOpen();
  const outlineWidth = useOutlineWidthBasedOnBreakpoint();
  const { document } = useGetCurrentDoc();
  const { isAtVersionHistoryRoute } = useIsAtVersionHistoryRoute();

  if (isAtVersionHistoryRoute) return null;
  if (!document?.workflow && !areHeadingsSupported) return null;

  return (
    <>
      <OutlineAnimationContainer animationWidth={80} isOpen={!isOpen}>
        <OutlineToggle handleOpen={() => setIsPageOutlineOpen(true)} />
      </OutlineAnimationContainer>
      <OutlineAnimationContainer animationWidth={outlineWidth} isOpen={isOpen}>
        <OutlineMenu
          areHeadingsSupported={areHeadingsSupported}
          handleClose={() => setIsPageOutlineOpen(false)}
        />
      </OutlineAnimationContainer>
    </>
  );
}
